<template>
  <div
    class="step"
    @click="callPopup(item.intents)"
    :class="item.fields[0].schema.this_stage.text == '1' ? 'current-step' : ''"
  >
    <div class="step__title">
      <div class="step-block__name">
        <p class="step__name">{{ stageName }}</p>
        <p
          v-if="item.fields[0].schema.required_to_pass.text == '1'"
          class="step__required"
        >
          *
        </p>
      </div>

      <Tooltip
        v-if="
          item.fields[0].schema.sla_error &&
          item.fields[0].schema.sla_error.text
        "
        :content="item.fields[0].schema.sla_error.text"
        :disabled="false"
        effect="dark"
      >
        <Icon iconName="CircleWarning" iconColor="#FC311E" />
      </Tooltip>
    </div>
    <div
      v-if="
        item.fields[0].schema.sla_expired ||
        item.fields[0].schema.sla_last_day ||
        item.fields[0].schema.sla_left
      "
      :class="[
        'step-sla',
        item.fields[0].schema.sla_expired.text
          ? 'step-sla--red'
          : item.fields[0].schema.sla_last_day.text
          ? 'step-sla--yellow'
          : item.fields[0].schema.sla_left.text
          ? 'step-sla--grey'
          : ''
      ]"
    >
      {{
        item.fields[0].schema.sla_expired.text ||
        item.fields[0].schema.sla_last_day.text ||
        item.fields[0].schema.sla_left.text
      }}
    </div>

    <div
      v-if="
        stageStatus &&
        ((item.fields[0].schema.this_stage.text == '1' &&
          stageStatusData?.access) ||
          stageStatusData?.value)
      "
      class="step-status"
    >
      <p>Статус</p>
      <Dropdown
        v-if="
          item.fields[0].schema.this_stage.text == '1' && stageStatusData.access
        "
        size="status"
        :options="this.statusOptions || []"
        :field="{
          type: 'enum',
          placeholder: 'Не выбран',
          disabled: !!isAccept
        }"
        :clearable="false"
        :model="stageStatusData.value || ''"
        @set-value="(name, value) => (!isAccept ? setValue(value) : null)"
      />

      <Tooltip
        v-else-if="stageStatusData.value"
        :content="getOptionStatus(stageStatusData.value)"
        :disabled="getOptionStatus(stageStatusData.value).length < 15"
        effect="dark"
      >
        <div class="step-status__name">
          {{ getOptionStatus(stageStatusData.value) || '' }}
        </div>
      </Tooltip>
    </div>
    <div class="step-info">
      <div class="step-info__left">
        <Picture :url="stageIcon ? stageIcon : ''" :class="iconColor()" />
        <p class="step__date">{{ stageDate }}</p>
      </div>
      <a
        v-if="stageAttachment && stageAttachmentText"
        class="step__attachment"
        @click="
          event => {
            event.stopPropagation();
            if (
              item.fields &&
              item.fields.length &&
              item.fields[1].linked_field &&
              item.fields[1].linked_field.intents
            ) {
              item.fields[1].linked_field.intents[0].intentArea == 'OldPage'
                ? goToOldPage(item.fields[1].linked_field.intents[0])
                : callPopup(item.fields[1].linked_field.intents);
            }
          }
        "
      >
        {{ formatHtml(stageAttachmentText) }}
      </a>
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import { MODULE, ACTION, INTENT_AREA, INTENT_TYPE } from '@/utils/constants';
import { mixin, stage, dialogMixin, errorMsg } from '@/utils/mixins';
import Picture from 'Elements/Picture/Picture';
import { getController, postController } from '@/controllers/request.js';
import Dropdown from 'Elements/Select/Dropdown';
import Tooltip from 'Elements/Tooltip/Tooltip';
import Icon from 'Elements/Icon/Icon';

export default {
  mixins: [mixin, stage, dialogMixin, errorMsg],

  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      MODULE,
      ACTION,
      noGroupPopup: true,
      statusOptions: []
    };
  },
  created() {
    if (this.stageStatus && this.stageStatusData?.options?.length) {
      for (let option in this.stageStatusData.options) {
        this.statusOptions.push({
          id: this.stageStatusData.options[option].id,
          name: this.stageStatusData.options[option].value,
          intents: this.stageStatusData.options[option].intents
        });
      }
    }
  },
  computed: {
    stageDate() {
      return this.item.fields[0].schema.date_start_stage.text
        ? new Date(
            this.item.fields[0].schema.date_start_stage.text.split(' ')[0]
          ).toLocaleDateString()
        : 'Не назначено';
    },
    stageName() {
      return this.item.fields[0].schema.stage_name.text || '';
    },
    stageIcon() {
      return this.item.fields[0].schema.done.icon || '';
    },
    stageStatus() {
      return !!this.item.fields[0].schema.stage_status || '';
    },
    stageStatusData() {
      return this.item.fields[0].schema.stage_status || {};
    },
    stageAttachment() {
      return this.item.fields[1] || null;
    },
    stageAttachmentText() {
      return this.item.fields[1].linked_field.text || null;
    },
    isAccept() {
      return this.stageName == 'Принят';
    }
  },
  methods: {
    async setValue(value) {
      let intents = this.statusOptions
        .filter(status => status.id == value)[0]
        .intents;
      store.commit('rightPanel/setParam', { name: 'loading', val: true });
      for (let index in intents) {
        if (intents[index].intentArea == INTENT_AREA.RIGHT_PANEL) {
          switch (intents[index].intentType) {
            case 'RightPanelDefs':
              store.dispatch('rightPanel/getMetadata', {
                intentOrRequest: intents[index].request,
                newCheck: false
              });
              store.commit('rightPanel/setParam', {
                name: 'panelMode',
                val: 'canditateStagePanel'
              });
              break;
            default:
              break;
          }
        } else {
          if (
            intents[index].request &&
            intents[index].request.url &&
            intents[index].request.request_params
          ) {
            try {
              const response = await getController({
                url: intents[index].request.url,
                params: intents[index].request.request_params
              });
              if (
                response?.data?.status &&
                response.data?.status == 'error' &&
                response.data?.error?.error_text
              ) {
                this.catchError('', response.data.error.error_text);
              }
            } catch (err) {
              this.catchError(err, 'Возникла ошибка');
            }
          }
        }
      }
      store.commit('rightPanel/setParam', { name: 'loading', val: false });
    },
    goToOldPage(item) {
      let url = item.request.url;

      if (item.request.request_params) {
        Object.keys(item.request.request_params).forEach(param => {
          url += `&${param}=${item.request.request_params[param]}`;
        });
      }
      let route = this.$router.resolve({
        name: '*',
        params: {
          url
        }
      });
      window.open(route.href, '_blank');
    },
    async callPopup(intents) {
      if (intents && intents.length) {
        if (
          intents[0].intentArea == INTENT_AREA.POPUP &&
          intents[0].intentType == INTENT_TYPE.EDIT
        ) {
          store.dispatch('dialog/getPopupData', {
            item: this.item.fields[1].linked_field
          });
        } else if (
          intents[0].intentType == INTENT_TYPE.GROUP_POPUP ||
          intents[0].intentArea == INTENT_AREA.AJAX
        ) {
          for (let i = 0; i < intents.length; i++) {
            if (
              intents[i].intentArea == INTENT_AREA.POPUP &&
              intents[i].intentType == INTENT_TYPE.GROUP_POPUP
            ) {
              this.noGroupPopup = false;
              store.commit('common/setVisibleDialog', {
                name: 'general_dialog',
                val: true,
                params: intents
              });
            }
            if (intents[i].request?.request_params) {
              for (let key in intents[i].request?.request_params) {
                if (key == 'vacancy_id') {
                  store.commit('rightPanel/setParam', {
                    name: 'vacancyId',
                    val: intents[i].request.request_params[key]
                  });
                }
              }
            }
          }
          store.commit('candidate/setSelectedStage', this.item);
          if (this.noGroupPopup) {
            store.commit('common/setVisibleDialog', {
              name: 'stage_dialog',
              val: true,
              params: intents
            });
          }
        } else {
          let url = intents[0].request.url;

          for (let key in intents[0].request.request_params) {
            url += `&${key}=${intents[0].request.request_params[key]}`;
          }

          try {
            const response = await getController({
              url
            });

            if (
              response.data.status == 'ok' ||
              (intents[0].intentArea == INTENT_AREA.CUSTOM_POPUP &&
                intents[0].intentType == INTENT_TYPE.EDIT)
            ) {
              for (let i = 0; i < intents.length; i++) {
                if (
                  intents[i].intentArea == INTENT_AREA.CUSTOM_POPUP &&
                  intents[i].intentType == INTENT_TYPE.EDIT
                ) {
                  let popUrl = intents[i].request.url;
                  const formData = new FormData();
                  for (let key in intents[i].request.request_params) {
                    formData.set(key, intents[i].request.request_params[key]);
                  }

                  try {
                    const resp = await postController({
                      url: popUrl,
                      options: formData
                    });
                    if (resp.data.show) {
                      store.commit('common/setVisibleDialog', {
                        name: 'warning_sb_dialog',
                        val: true,
                        params: { ...resp.data, intents }
                      });
                      store.commit('candidate/setSelectedStage', this.item);
                      return;
                    }
                  } catch (err) {
                    console.error('err', err);
                    return;
                  }
                }
                if (
                  intents[i].intentArea == INTENT_AREA.POPUP &&
                  intents[i].intentType == INTENT_TYPE.GROUP_POPUP
                ) {
                  this.noGroupPopup = false;
                  store.commit('common/setVisibleDialog', {
                    name: 'general_dialog',
                    val: true,
                    params: intents
                  });
                }
                if (intents[i].request?.request_params) {
                  for (let key in intents[i].request?.request_params) {
                    if (key == 'vacancy_id') {
                      store.commit('rightPanel/setParam', {
                        name: 'vacancyId',
                        val: intents[i].request.request_params[key]
                      });
                    }
                  }
                }
              }
              store.commit('candidate/setSelectedStage', this.item);
              if (this.noGroupPopup) {
                store.commit('common/setVisibleDialog', {
                  name: 'stage_dialog',
                  val: true,
                  params: intents
                });
              }
            } else if (response.data.status == 'error') {
              this.catchError(
                {},
                `Нельзя перевести на этап. ${response.data.title}`
              );
            }
          } catch (err) {
            this.catchError(err, 'Возникла ошибка');
          } finally {
            this.noGroupPopup = true;
          }
        }
      }
    },
    iconColor() {
      return this.item.fields[0].schema.done.icon
        ? this.item.fields[0].schema.done.icon.includes('CircleOk')
          ? 'step-passed'
          : ''
        : '';
    },
    getOptionStatus(optionId) {
      if (this.stageStatus && this.stageStatusData?.options?.length) {
        return (
          this.stageStatusData?.options.filter(opt => opt.id == optionId)[0]
            .value || ''
        );
      } else {
        return '';
      }
    }
  },
  components: {
    Picture,
    Dropdown,
    Tooltip,
    Icon
  }
};
</script>

<style lang="scss" scoped>
.current-step {
  background: $grey8;
}

.step {
  display: flex;
  flex-direction: column;
  border: 1px solid $grey12;
  border-radius: 4px;
  padding: 8px 12px;
  max-width: 288px;

  &__title {
    display: flex;
    justify-content: space-between;
  }

  &-block__name {
    display: flex;
  }

  &__name {
    font-family: Roboto Medium;
    text-align: left;
    word-break: break-word;
    font-size: 15px;
    line-height: 24px;
  }

  &__required {
    color: $red;
  }

  &-info {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;

    &__left {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  &-status {
    display: flex;
    margin-top: 8px;
    text-align: left;
    gap: 8px;
    height: 24px;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: $black;

    &__name {
      background: $blue40;
      color: $white;
      padding: 2px 8px;
      max-width: 120px;
      height: 24px;
      border-radius: 4px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &__date {
    color: $grey64;
    font-size: 15px;
    line-height: 24px;
  }

  &__attachment {
    font-size: 16px;
    line-height: 24px;
    padding: 0;
    color: $blue64;
    text-decoration: none;
    width: fit-content;
    text-align: right;
  }

  &-sla {
    text-align: left;
    white-space: nowrap;
    width: min-content;
    border-radius: 4px;
    font-size: 14px;
    margin-top: 8px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    padding: 2px 8px;

    &--yellow {
      background: $yellow;
      color: $grey80;
    }

    &--red {
      color: $white;
      background: $red;
    }

    &--grey {
      background: $grey12;
      color: $grey64;
    }
  }

  &-passed {
    filter: invert(45%) sepia(47%) saturate(6820%) hue-rotate(192deg)
      brightness(102%) contrast(106%);
  }

  &:hover {
    border: 1px solid $blue64;
    background: $blue8;
  }
}
</style>
